module.exports = __webpack_public_path__ + "static/media/linkedin.a23f0ca7.svg";